import { useState, useRef } from "react";
import styled from "styled-components";
import stringSimilarity from "string-similarity";

//---------------------------------------------------------

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  flex: 1;
`;

const TopContainer = styled.div`
  width: 100%;
  height: 30px;
`;

const Input = styled.input`
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: whitesmoke;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 13px;
`;

const ListContainer = styled.div`
  flex: 1;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 0 5px 0 0;
  overflow: auto;
`;

const Draft = styled.div`
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: whitesmoke;
  }
`;

//---------------------------------------------------------

const RolesList = ({ onSelect, data }) => {
  const [searchInput, setSearchInput] = useState("");
  const listRef = useRef();
  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    listRef.current.scrollTop = 0;
  };

  // Calculate the similarity scores
  const similarities = stringSimilarity.findBestMatch(
    searchInput.toLowerCase(),
    data.map((mp) => mp.title.toLowerCase())
  );

  // Get the most similar strings
  const mostSimilarStrings = similarities.ratings.map((rating, index) => ({
    string: data.map((d) => d.title)[index],
    rating: rating.rating,
    id: data.map((d) => d._id)[index],
  }));

  // Sort by similarity score (higher score means more similar)
  const sorted = mostSimilarStrings.sort((a, b) => b.rating - a.rating);

  return (
    <Wrapper>
      <TopContainer>
        <Input
          autoFocus
          placeholder="Search..."
          autoCapitalize="none"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          value={searchInput}
          onChange={handleInputChange}
        />
      </TopContainer>
      <ListContainer ref={listRef}>
        {sorted.map((item, i) => {
          return (
            <Draft
              key={`${item.id}_${i}`}
              onClick={() => {
                const dr = data.find((i) => i._id === item.id);
                onSelect(dr);
              }}
            >
              {item.string}
            </Draft>
          );
        })}
      </ListContainer>
    </Wrapper>
  );
};

export default RolesList;
